<mat-dialog-content [formGroup]="userForm">
    <div class="flex flex-col">
        <h1 for="role" class="text-gray-700">Rol</h1>
        <select id="role" (change)="assingRole($event)" formControlName="role" matNativeControl
            class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
            <option value="">Seleccione un rol</option>
            <option value="ROLE_ADMIN">ROLE_ADMIN</option>
            <option value="ROLE_CRM">ROLE_CRM</option>
            <option value="ROLE_CONSULTANT">ROLE_CONSULTANT</option>
        </select>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="justify-between">
    <button class="bg-orange-400 hover:bg-orange-500 text-white font-bold py-2 px-4 mb-3 rounded" mat-button
        type="submit" (click)="handleChangeRole()">Cambiar rol</button>
    <button class="bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 mb-3 ml-5 rounded" mat-button
        (click)="closeModal()">Cancelar</button>
</mat-dialog-actions>

<!-- <mat-dialog-content [formGroup]="userForm">

    <div class="flex flex-col mt-4">
        <label for="role" class="text-gray-700">Rol</label>
        <select id="role" formControlName="role" matNativeControl
            class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
            <option value="">Seleccione un rol</option>
            <option *ngFor="let role of roles" [value]="role">{{ role }}</option>
        </select>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="justify-between mt-4">
    <button class="bg-orange-400 hover:bg-orange-500 text-white font-bold py-2 px-4 mb-3 rounded" mat-button
        type="submit" (click)="handleChangeRole()">Cambiar rol</button>
    <button class="bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 mb-3 ml-5 rounded" mat-button
        (click)="closeModal()">Cancelar</button>
</mat-dialog-actions> -->